<template>
    <div class="login-entry" @mouseenter="hover = true" @mouseleave="hover = false">
        <div class="login-box">
            <div class="login-top" @click="entryLogin">
                <div class="avatar"></div>
                <div class="login-text">
                    <span v-for="(char, index) in loginLabel" :key="index">{{ char }}</span>
                </div>
            </div>
            <div class="login-bottom">
                <img src="../../static/webp1/entry-login.png" alt="" class="login-icon" />
                <img src="../../static/webp1/entry-register.png" alt="" class="login-icon" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            hover: false,
            loginLabel: "校内用户登录".split(""),
        };
    },
    methods: {
        entryLogin() {
            window.open(window.osConfig.eproAssetUrl,'_blank');
        },
    },
};
</script>

<style scoped lang="less">
.login-entry {
    position: fixed;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    z-index: 999;
}

.login-box {
    width: 36px;
}

.login-top {
    width: 36px;
    height: 166px;
    background-image: linear-gradient(
        180deg,
        #1264fd 0%,
        #1469fd 45%,
        #49acff 100%
    );
    box-shadow: 0 2px 10px 0 rgba(74, 103, 168, 0.3);
    border-radius: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 8px;
    cursor: pointer;
}

.avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: url("../../static/img1/默认头像3.png") center center / cover
        no-repeat;
    margin-bottom: 6px;
}

.login-text {
    writing-mode: vertical-rl;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 1.6;
    letter-spacing: 6px;
}

.login-bottom {
    margin-top: 12px;
    width: 36px;
    height: 72px;
    background: #ffffff;
    box-shadow: 0 2px 10px 0 rgba(74, 103, 168, 0.3);
    border-radius: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
        width: 28px;
        height: 28px;
        cursor: pointer;
    }
}

.login-icon {
    margin: 2px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/login-entry.vue